import { ReactWebComponent } from '@app/utils/web-components'
import { lazy, Suspense } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const DeleteFilterModal = lazy(() => import('./DeleteFilterModal'))
const MainSpinner = lazy(() => import('@app/components/MainSpinner'))

// Lets the legacy editor delete filters through the same modal as the rest of the app, so it
// also refuses to delete a filter that workflows still use.
class DeleteFilterModalComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['project-id', 'filter-id']
  }

  override render() {
    const projectId = this.prop('project-id')
    const filterId = this.prop('filter-id')

    return (
      <AppProviders>
        {filterId && (
          <Suspense fallback={<MainSpinner />}>
            <DeleteFilterModal
              projectId={projectId}
              filterId={filterId}
              onSuccess={(deletedFilterId) => {
                this.dispatchEvent(new CustomEvent('deleted', { detail: deletedFilterId }))
              }}
              onCancel={() => {
                this.dispatchEvent(new Event('close'))
              }}
            />
          </Suspense>
        )}
      </AppProviders>
    )
  }
}

customElements.define('delete-filter-modal', DeleteFilterModalComponent)
